import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import InventoryAdjustmentTableSection from "../../components/inventory/adjustment/InventoryAdjustmentTableSection";

const InventoryAdjustmentsPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <InventoryAdjustmentTableSection/>
    </DefaultLayout>
  );
};

export default InventoryAdjustmentsPage;
